<!-- 协议选择 -详情 -->
<template>
  <div>
    <div class="choose-detail">
      <div class="choose-detail-title">
        <h1>{{agreeDetail.agreement.title}}</h1>
        <p>{{agreeDetail.agreement.sendTime | filterTime}}</p>
      </div>
    </div>
    <div class="choose-intention"
         v-for="(projectsItem,key,index) in agreeDetail.projects"
         :key="index">
      <div class="choose-intention-con">
        <p class="choose-intention-title">{{key | filterTitle}}</p>
        <div class="choose-detail-table">
          <Table :columns="tableColumns"
                 :data="projectsItem"
                 :border=true></Table>
        </div>
      </div>
    </div>
    <div class="choose-intention">
      <div class="choose-intention-con">
        <p class="choose-intention-title">项目协议</p>
        <pre class="dis-bot-20"
             v-if="agreeDetail.agreement.explain">{{agreeDetail.agreement.explain}}</pre>
        <div>
          <div v-if="agreeDetail.agreement.qiyuesuo" class="dis-bot-20">
           <a v-if="isallowedit" href="javascript: void(0);" @click="seeAgreemenDetail">查看协议</a>
          </div>
          <div v-else>
            <div class="dis-bot-20">
            电子签名操作指南MAC版：<a href="javascript: void(0);" @click="downloadSignMac">下载</a>
            </div>
            <div class="dis-bot-20">
            电子签名操作指南Windows版：<a href="javascript: void(0);" @click="downloadSignWin">下载</a>
            </div>
            <div class="dis-bot-20">
              初始协议 :{{agreeDetail.agreement.initialAgreement && agreeDetail.agreement.initialAgreement.originFileName}}
              <span class="file-download"
                    :class="{'file-disabled': hasBack || hasEffect}"
                    @click="handleInitialAgreement">下载</span>
              <span class="file-finish"
                    v-if="hasInital">已完成</span>
            </div>
            <div class="dis-bot-20">
              协议回传（待盖章）：{{agreeDetail.agreement.backAgreement && agreeDetail.agreement.backAgreement.originFileName}}
              <span class="file-download"
                    :class="{'file-disabled': hasEffect || hasBack}"
                    @click="handleUploadBefore">上传</span>
              <span class="file-finish"
                    v-if="hasBack">已完成</span>
            </div>
            <div>
              生效协议（已盖章）：{{agreeDetail.agreement.effectAgreement && agreeDetail.agreement.effectAgreement.originFileName}}
              <span class="file-download"
                    :class="{'file-disabled': !hasEffect}"
                    @click="handleDownloadEffect">下载</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 上传文件 -->
    <zlr-modal v-model="upload.modal">
      <div class="upload">
        <h1>回传协议</h1>
        <p class="upload-title">协议上传成功后，将不能再次上传协议，请谨慎上传</p>
        <zlr-upload :path="uploadPath"
                    :size="10"
                    @on-error="uploadError"
                    @on-success="uploadSuccess"
                    v-model="upload.data"></zlr-upload>
        <p class="upload-prompt"
           v-if="upload.prompt">只能上传10MB大小以下的文件</p>
        <div class="upload-btn">
          <Button type="default"
                  class="zlr-btn-default"
                  @click="upload.modal = false">关闭</Button>
          <Button type="primary"
                  class="zlr-btn-primary"
                  style="margin-left:32px;"
                  :disabled="!upload.data"
                  @click="handleUpload">上传</Button>
        </div>
      </div>
    </zlr-modal>
  </div>
</template>

<script>
import isAllowEdit from '@/view/mixins/is-edit'
// API
import { getAgreemenDetail, seeAgreemenDetail } from '@/api/agreement'
import { ossSecretLink } from '@/api/oss'
import { subPreProjectAgreementUpload } from '@/api/pre'
// components
import ZlrModal from '@/components/modal/modal'
import ZlrUpload from '@/components/upload/upload'
// constant
import { agreeProjectTypeMap } from '@/constant'
import { getObjValue } from '@/libs/tools'
import dayjs from 'dayjs'
import axios from 'axios'
export default {
  name: '',
  mixins: [isAllowEdit],
  components: {
    ZlrModal,
    ZlrUpload
  },
  data () {
    return {
      tableColumns: [
        {
          title: '序号',
          type: 'index',
          align: 'center'
        },
        {
          title: '学校',
          key: 'title',
          align: 'center',
          render: (h, params) => {
            let title = (params.row.overseasBasicInfo && params.row.overseasBasicInfo.univer) || ''
            return h('span', title)
          }
        },
        {
          title: '项目',
          key: 'title',
          align: 'center',
          render: (h, params) => {
            let title = (params.row.overseasBasicInfo && params.row.overseasBasicInfo.name) || ''
            return h('span', title)
          }
        },
        {
          title: '截止日期',
          key: 'name',
          align: 'center',
          render: (h, params) => {
            let deadlines = params.row.deadlines || []
            if (deadlines.length === 0) {
              return h('span', '--')
            }
            return h('span', deadlines.join(','))
          }
        },
        {
          title: '定档',
          key: 'location',
          align: 'center'
        }
      ],
      upload: {
        modal: false,
        prompt: true,
        data: '',
        file: {},
        loading: false
      },
      agreeDetail: {
        projects: {},
        agreement: {}
      }
    }
  },
  computed: {
    uploadPath () {
      return `docs/project/mentee/agreement/${this.agreeDetail.agreement.menteeNum}/${this.agreeDetail.agreement.id}/back`
    },
    hasInital () {
      return !!(this.agreeDetail.agreement.initialAgreement && this.agreeDetail.agreement.initialAgreement.fileUrl)
    },
    hasBack () {
      return !!(this.agreeDetail.agreement.backAgreement && this.agreeDetail.agreement.backAgreement.fileUrl)
    },
    hasEffect () {
      return !!(this.agreeDetail.agreement.effectAgreement && this.agreeDetail.agreement.effectAgreement.fileUrl)
    }
  },
  mounted () {
    this.getAgreemenDetail()
  },
  methods: {
    // 获取协议详情
    getAgreemenDetail () {
      getAgreemenDetail({
        id: this.$route.query.id
      }).then(res => {
        this.agreeDetail = res.data
      })
    },
    uploadSuccess (data) {
      this.upload.file = data
    },
    handleUploadBefore () {
      if (this.hasBack || this.hasEffect) return false
      this.upload = {
        data: '',
        modal: true,
        prompt: true,
        file: {},
        loading: false
      }
    },
    // 确认上传
    handleUpload () {
      let file = this.upload.file
      this.upload.loading = true
      subPreProjectAgreementUpload({
        originFileName: file.name,
        fileUrl: this.upload.data,
        fileType: 'BACK',
        agreementId: this.$route.query.id
      }).then(res => {
        this.$zlr_message('上传成功', 'success')
        this.upload.modal = false
        this.getAgreemenDetail()
      }).catch((error) => {
        this.$zlr_message(error.message, 'error')
      }).then(() => {
        this.upload.loading = false
      })
    },
    // 上传失败
    uploadError () {
      this.upload.prompt = false
    },
    handleInitialAgreement () {
      if (this.hasBack || this.hasEffect) return false
      let initialAgreement = this.agreeDetail.agreement.initialAgreement
      if (!initialAgreement || !initialAgreement.fileUrl) {
        return false
      }
      this.getDownlod(initialAgreement.fileUrl)
    },
    // 签名下载MAC
    downloadSignMac () {
      this.downloadByDownloadName('电子签名操作指南MAC版.pdf', 'https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/msp/docs/sign/%E5%A6%82%E4%BD%95%E5%9C%A8PDF%E6%96%87%E4%BB%B6%E4%B8%AD%E5%88%B6%E4%BD%9C%E7%94%B5%E5%AD%90%E7%AD%BE%E5%90%8D-MAC.pdf')
    },
    // 签名下载Wins
    downloadSignWin () {
      this.downloadByDownloadName('电子签名操作指南Windows版.pdf', 'https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/msp/docs/sign/%E5%A6%82%E4%BD%95%E5%9C%A8PDF%E6%96%87%E4%BB%B6%E4%B8%AD%E5%88%B6%E4%BD%9C%E7%94%B5%E5%AD%90%E7%AD%BE%E5%90%8D-Windows.pdf')
    },
    // 绝对路径下载
    downloadByDownloadName (name, url) {
      axios.request({
        url: url,
        method: 'get',
        responseType: 'blob'
      }).then(res => {
        let url = window.URL.createObjectURL(new Blob([res.data]))
        let link = document.createElement('a')
        link.href = url
        link.setAttribute('download', name)
        link.click()
      }).catch((error) => {
        this.$zlr_message('下载失败', 'error')
      })
    },
    // 盖章下载
    handleDownloadEffect () {
      if (!this.hasEffect) return false
      this.getDownlod(this.agreeDetail.agreement.effectAgreement.fileUrl)
    },
    getDownlod (dir) {
      ossSecretLink({
        dir
      }).then(res => {
        if (res.code === 0) {
          window.open(res.data.url)
        } else {
          this.$zlr_message('下载失败', 'error')
        }
      })
    },
    // 查看协议
    seeAgreemenDetail () {
      let agreementId = this.$route.query.id
      seeAgreemenDetail(agreementId).then(res => {
        if (res.code === 0) {
          let qiYueLink = res.data.model
          window.open(qiYueLink)
        }
      })
    }
  },
  filters: {
    filterTitle (value) {
      if (!value) return ''
      return getObjValue(agreeProjectTypeMap, value)
    },
    filterTime (value) {
      return dayjs(value).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
<style lang='less' scoped>
.dis-bot-20 {
  margin-bottom: 20px;
}
.file-download {
  margin-left: 20px;
  color: #6589dd;
  cursor: pointer;
}
.file-finish {
  margin-left: 20px;
  color: @c-success;
}
.file-disabled {
  color: #999;
  cursor: not-allowed;
}
.upload {
  width: 960px;
  > h1 {
    font-size: 20px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 30px;
    line-height: 20px;
    margin-bottom: 24px;
  }
  &-title {
    color: @c-warning;
    margin-bottom: 10px;
  }
  &-prompt {
    color: @c-warning;
  }
  &-btn {
    text-align: right;
    margin-top: 24px;
  }
}
</style>
